import React, { Component } from 'react'
import style from './style.css'

class Button extends Component {
    constructor(props) {
        super(props)
        this.state = {
            color: style.default,
            inlineClass: '',
            disabled: '',
            min: '',
        }
        this.handleProps = this.handleProps.bind(this)
    }

    handleProps(props) {
        var color = (props.color) ? style[props.color] : this.state.color
        var inlineClass = (props.inline) ? style['inline'] : ''
        var disabled = (props.disabled) ? style['disabled'] : ''
        var min = (props.min) ? style['min'] : ''
        this.setState({
            color,
            inlineClass,
            disabled,
            min,
        })
    }

    componentWillMount() {
        this.handleProps(this.props)
    }

    componentWillReceiveProps(nextProps) {
        this.handleProps(nextProps)
    }

    render() {
        return (
            <button
                type={this.props.type || 'submit'}
                className={`${style.btn} ${this.state.color} ${this.state.inlineClass} ${this.state.disabled} ${this.state.min}`}
                onClick={this.props.onClick || null}
                style={this.props.style}
                disabled={this.props.disabled || false}
            >
                {this.props.children || this.props.label || ''}
            </button>
        )
    }
}

export default Button


// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/atoms/Button/index.js